const SEO = [
	{
		page: "home",
		description:
			"In addition to developing games with Unity, I have experience in web and software development, mostly with academic and practical applications towards games.",
		keywords: ["Daniel", "Rosenthal", "Daniel Rosenthal"],
	},

	{
		page: "about",
		description:
			"In addition to developing games with Unity, I have experience in web and software development, mostly with academic and practical applications towards games.",
		keywords: ["Daniel", "Rosenthal", "Daniel Rosenthal"],
	},

	{
		page: "articles",
		description:
			"In addition to developing games with Unity, I have experience in web and software development, mostly with academic and practical applications towards games.",
		keywords: ["Daniel", "Rosenthal", "Daniel Rosenthal"],
	},

	{
		page: "projects",
		description:
			"In addition to developing games with Unity, I have experience in web and software development, mostly with academic and practical applications towards games.",
		keywords: ["Daniel", "Rosenthal", "Daniel Rosenthal"],
	},

	{
		page: "contact",
		description:
			"In addition to developing games with Unity, I have experience in web and software development, mostly with academic and practical applications towards games.",
		keywords: ["Daniel", "Rosenthal", "Daniel Rosenthal"],
	},
];

export default SEO;
